/**
 * RA Documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LookingForProjectCreateDTO { 
    status: LookingForProjectCreateDTO.StatusEnum;
    employeeId: number;
    assigneeId: number;
    freeFrom: string;
    fte?: number;
    comment?: string;
}
export namespace LookingForProjectCreateDTO {
    export type StatusEnum = 'WAITING' | 'IN_PROGRESS' | 'DONE';
    export const StatusEnum = {
        Waiting: 'WAITING' as StatusEnum,
        InProgress: 'IN_PROGRESS' as StatusEnum,
        Done: 'DONE' as StatusEnum
    };
}


